<script setup lang="ts">
import CanvasButton from "@/components/canvas/CanvasButton.vue";
import MeasurementKeypadState from "@/stores/MeasurementKeypadState";

function toggle() {
  MeasurementKeypadState.isOpen = !MeasurementKeypadState.isOpen;
}
</script>
<template>
  <CanvasButton
    @click.prevent.stop="toggle"
    phosphor-icon="keyboard"
    :tooltipTitle="$t('canvas:tools.options.keypad.tooltip.title')"
    :tooltipText="$t('canvas:tools.options.keypad.tooltip.text')"
    :mode="MeasurementKeypadState.isOpen"
  />
</template>
